import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Scale } from "lucide-react";

const LOGO_URL =
  "/assets/logo.png";

const EDITEUR_FIELDS = [
  { k: "Exploitant du site", v: "ANNUAIRE DES ENTREPRISES FRANCAISES" },
  { k: "Entreprise", v: "ANNUAIRE DES ENTREPRISES FRANCAISES" },
  { k: "Forme juridique", v: "Entreprise individuelle" },
  { k: "Siège social", v: "27 T RUE AUX ANGLAIS, 76100 ROUEN" },
  { k: "SIRET", v: "52832623400044 — RCS de Rouen" },
  { k: "Dirigeant", v: "Ahonon Kouassi" },
  { k: "Propriétaire du site", v: "Sorel Steeven" },
  { k: "Responsable de la publication", v: "Sorel Steeven" },
  {
    k: "Email de contact",
    v: (
      <a href="mailto:contact@mapageentreprise.fr" className="font-semibold text-[#2FA398] hover:underline">
        contact@mapageentreprise.fr
      </a>
    ),
  },
];

const ARTICLES = [
  {
    n: "1",
    title: "Éditeur du site",
    body: (
      <>
        <p>
          Le site <strong>LeGuidedesEntrepreneurs.fr</strong> est édité par&nbsp;:
        </p>
        <dl className="mt-4 divide-y divide-slate-100 overflow-hidden rounded-xl border border-slate-200 bg-slate-50">
          {EDITEUR_FIELDS.map(({ k, v }) => (
            <div
              key={k}
              className="grid grid-cols-1 gap-1 px-4 py-3 sm:grid-cols-[220px_1fr] sm:gap-4"
            >
              <dt className="text-xs font-bold uppercase tracking-widest text-slate-500">
                {k}
              </dt>
              <dd className="text-sm font-semibold text-[#1E2A5E]">{v}</dd>
            </div>
          ))}
        </dl>
      </>
    ),
  },
  {
    n: "2",
    title: "Hébergement",
    body: (
      <p>
        Le site est hébergé par <strong>IONOS</strong> — la plateforme assure
        l&apos;hébergement, l&apos;infrastructure technique et la distribution
        du contenu.
      </p>
    ),
  },
  {
    n: "3",
    title: "Propriété intellectuelle",
    body: (
      <>
        <p>
          L&apos;ensemble du contenu du site (textes, graphismes, logo, icônes,
          images, code, modèles de pages) est la propriété exclusive de{" "}
          <strong>LeGuidedesEntrepreneurs.fr</strong>, à l&apos;exception des
          marques, logos et contenus appartenant à des tiers expressément
          identifiés.
        </p>
        <p>
          Toute reproduction, représentation, modification ou exploitation,
          totale ou partielle, sans autorisation écrite préalable, est
          strictement interdite et constituerait une contrefaçon sanctionnée
          par les articles L335-2 et suivants du Code de la propriété
          intellectuelle.
        </p>
      </>
    ),
  },
  {
    n: "4",
    title: "Protection des données personnelles (RGPD)",
    body: (
      <>
        <p>
          LeGuidedesEntrepreneurs.fr collecte et traite les données
          personnelles strictement nécessaires à la fourniture du service
          (email, nom de l&apos;entreprise, coordonnées de contact, contenu de
          la page personnalisée).
        </p>
        <p>
          Conformément au Règlement Général sur la Protection des Données
          (RGPD) et à la loi «&nbsp;Informatique et Libertés&nbsp;», vous
          disposez d&apos;un droit d&apos;accès, de rectification,
          d&apos;effacement, de limitation, d&apos;opposition et de
          portabilité de vos données. Pour exercer ces droits, contactez-nous à{" "}
          <a
            href="mailto:contact@mapageentreprise.fr"
            className="font-semibold text-[#2FA398] hover:underline"
          >
            contact@mapageentreprise.fr
          </a>
          .
        </p>
        <p>
          Les données sont conservées tant que votre page est active, puis
          archivées <strong>3 ans</strong> après cessation d&apos;activité,
          conformément à la durée légale.
        </p>
      </>
    ),
  },
  {
    n: "5",
    title: "Cookies",
    body: (
      <>
        <p>
          Le site utilise uniquement les cookies strictement nécessaires à son
          fonctionnement (session, authentification) ainsi que, le cas
          échéant, des cookies de mesure d&apos;audience anonymisée. Aucun
          cookie publicitaire tiers n&apos;est déposé.
        </p>
        <p>
          Vous pouvez configurer votre navigateur pour refuser les cookies ;
          cette configuration peut toutefois altérer certaines fonctionnalités
          du site.
        </p>
      </>
    ),
  },
  {
    n: "6",
    title: "Paiement et facturation",
    body: (
      <p>
        Les paiements sont traités par <strong>Stripe</strong>, prestataire
        certifié PCI-DSS de niveau 1. LeGuidedesEntrepreneurs.fr ne stocke ni
        les numéros de carte ni les cryptogrammes. Une facture est générée
        automatiquement et envoyée par e-mail à chaque commande.
      </p>
    ),
  },
  {
    n: "7",
    title: "Limitation de responsabilité",
    body: (
      <p>
        LeGuidedesEntrepreneurs.fr ne saurait être tenue responsable de toute
        interruption, indisponibilité ou perte de données indépendante de sa
        volonté (cas de force majeure, défaillance d&apos;un prestataire
        tiers, incidents techniques).
      </p>
    ),
  },
  {
    n: "8",
    title: "Droit applicable",
    body: (
      <p>
        Les présentes mentions légales sont régies par le droit français. Tout
        litige sera soumis aux tribunaux compétents du ressort du siège social
        de l&apos;Éditeur, sous réserve des dispositions impératives
        applicables.
      </p>
    ),
  },
];

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="mentions-legales-page">
      {/* Header */}
      <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Le Guide des Entrepreneurs" className="h-8 w-auto sm:h-10" />
          </Link>
          <Link
            to="/"
            data-testid="mentions-back-home"
            className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-[10px] font-semibold text-[#1E2A5E] transition-colors hover:border-[#2FA398] hover:text-[#2FA398] sm:px-4 sm:py-2 sm:text-xs"
          >
            <ArrowLeft className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
            Retour à l&apos;accueil
          </Link>
        </div>
      </header>

      {/* Hero */}
      <section className="border-b border-slate-100 bg-gradient-to-b from-white to-slate-50">
        <div className="mx-auto max-w-4xl px-4 py-8 text-center sm:px-6 sm:py-12 lg:py-16 lg:px-8">
          <div className="mx-auto mb-4 flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-[#1E2A5E] to-[#2FA398] shadow-lg shadow-[#1E2A5E]/20 sm:mb-5 sm:h-14 sm:w-14">
            <Scale className="h-5 w-5 text-white sm:h-7 sm:w-7" strokeWidth={2} />
          </div>
          <span className="inline-block rounded-full border border-[#2FA398]/30 bg-white px-3 py-1 font-mono text-[9px] font-bold uppercase tracking-widest text-[#2FA398] sm:px-4 sm:py-1.5 sm:text-[10px]">
            Informations légales
          </span>
          <h1
            data-testid="mentions-title"
            className="mt-3 text-2xl font-extrabold leading-tight tracking-tight text-[#1E2A5E] sm:mt-4 sm:text-3xl lg:text-5xl"
          >
            Mentions Légales
          </h1>
          <p className="mx-auto mt-3 max-w-2xl text-xs leading-relaxed text-slate-600 sm:mt-4 sm:text-sm lg:text-base">
            Informations sur l&apos;éditeur, l&apos;hébergement et le traitement
            de vos données sur{" "}
            <span className="font-semibold text-[#1E2A5E]">
              LeGuidedesEntrepreneurs.fr
            </span>
            .
          </p>
        </div>
      </section>

      {/* Content */}
      <main className="mx-auto max-w-4xl px-4 py-8 sm:px-6 sm:py-12 lg:py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-5 sm:gap-8">
          {ARTICLES.map(({ n, title, body }) => (
            <article
              key={n}
              id={`article-${n}`}
              data-testid={`mentions-article-${n}`}
              className="relative rounded-2xl border border-slate-200 bg-white p-5 shadow-[0_4px_20px_-4px_rgba(30,42,94,0.06)] transition-shadow hover:shadow-[0_12px_30px_-12px_rgba(30,42,94,0.14)] sm:p-6 lg:p-8"
            >
              <span className="absolute inset-y-4 left-0 w-1 rounded-full bg-gradient-to-b from-[#1E2A5E] to-[#2FA398]" />
              <header className="mb-3 flex items-start gap-3 sm:mb-4 sm:gap-4">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#1E2A5E] font-mono text-xs font-bold text-white shadow-sm sm:h-10 sm:w-10 sm:rounded-xl sm:text-sm">
                  {n}
                </span>
                <h2 className="pt-1 text-base font-extrabold leading-tight text-[#1E2A5E] sm:pt-1.5 sm:text-lg lg:text-xl">
                  {title}
                </h2>
              </header>
              <div className="prose prose-slate max-w-none space-y-2.5 text-[13px] leading-relaxed text-slate-700 sm:space-y-3 sm:text-sm lg:text-[15px] [&_strong]:text-[#1E2A5E]">
                {body}
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 flex justify-center sm:mt-12">
          <Link
            to="/"
            data-testid="mentions-back-home-bottom"
            className="inline-flex items-center gap-2 rounded-full bg-[#1E2A5E] px-5 py-2.5 text-xs font-bold text-white shadow-sm transition-colors hover:bg-[#2A3B7A] sm:px-6 sm:py-3 sm:text-sm"
          >
            <ArrowLeft className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
            Retour à l&apos;accueil
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 bg-white">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 py-5 text-center sm:flex-row sm:text-left sm:px-6 sm:py-6 lg:px-8">
          <img src={LOGO_URL} alt="Le Guide des Entrepreneurs" className="h-7 w-auto sm:h-9" />
          <p className="text-[10px] text-slate-500 sm:text-[11px]">
            © {new Date().getFullYear()}{" "}
            <a
              href="https://leguidedesentrepreneurs.fr/"
              className="font-semibold text-[#1E2A5E] hover:text-[#2FA398]"
              target="_blank"
              rel="noopener noreferrer"
            >
              Le Guide des Entrepreneurs.fr
            </a>{" "}
            — Tous droits réservés.
          </p>
        </div>
      </footer>
    </div>
  );
}
